import * as types from '../Actions/actionTypes';

const reducer = (state = { version: 0 }, action) => {
    switch (action.type) {
        case types.CALL_API:
        case types.ADD_PAYMENT:
        case types.REMOVE_PAYMENT:
        case types.COMMIT:
            if (action.readyState === 'request') 
                return state;

            return { version: new Date().getTime() }
        default:
            return state;
    }
}

export default reducer;